import React, {useCallback, useEffect, useState} from 'react';
import {useParams, Redirect, useLocation} from 'react-router-dom';
import { Button, FormGroup, Loading, Icon, Toast } from "spectre-react/dist/cjs";
import { SETTINGS_PATH } from '../paths';
import { useFetch } from '../hooks';
import ErrorToast from "./shared/ErrorToast";
import {URL_SPECIAL_DOC} from "../api";


const SpecialDocEditPage = () => {
    const { docId } = useParams();
    const location = useLocation();

    const url = URL_SPECIAL_DOC(docId);

    const [fetchSt] = useFetch(url, { now: true });
    const [submitSt, submitAct] = useFetch(url);

    const [docText, setDocText] = useState("");

    useEffect(() => {
        if (fetchSt.response)
            setDocText(JSON.stringify(fetchSt.response, null, 2));
    }, [fetchSt.response, setDocText]);

    const handleSubmit = useCallback((ev) => {
        ev.preventDefault();
        const text = ev.target.elements.docText.value;
        try {
            const parsed = JSON.parse(text);
            submitAct.doFetch({method: 'post', data: parsed});
        } catch (error) {
            const reason = `В поле содержится невалидный JSON:\n${error.message}`;
            submitAct.setError({response: {data: {reason}}});
        }
    }, [submitAct.doFetch, submitAct.setError]);

    // -----

    if (fetchSt.error)
        return (
            <div className="empty">
                <div className="empty-icon">
                    <Icon icon="cross" size="3x"/>
                </div>
                <p className="empty-title h5">Ошибка</p>
                <p className="empty-subtitle">{fetchSt.errorReason}</p>
            </div>
        );

    if (!docText)
        return <Loading large />;

    if (submitSt.response && !submitSt.error) {
        alert('Изменения успешно внесены.');
        if (location?.state?.from)
            return <Redirect to={location.state.from} />;
        else
            return <Redirect to={SETTINGS_PATH} />;
    }

    return (
        <form className="container grid-xl" id="special-doc-edit-page" onSubmit={handleSubmit}>
            <div className="h2">Редактирование документа</div>

            <FormGroup>
                <textarea id="docText" className="form-input" rows="25" defaultValue={docText}></textarea>
            </FormGroup>

            <div className="form-actions">
                {submitSt.error && (
                    <ErrorToast className="mb-2" onButtonClick={submitAct.clearError}>
                        {submitSt.errorReason}
                    </ErrorToast>
                )}

                <Button primary loading={submitSt.isLoading}>
                    Сохранить
                </Button>
            </div>
        </form>
    );
};


export default SpecialDocEditPage;